export enum ClientMessages {
    ClientAddedSuccessMessage = "Client Added Successfully.",
    ClientUpdatedSuccessMessage = "Client Updated Successfully.",
    ClientDeletedSuccessMessage = "Client Deleted Successfully.",
  }

  export enum CommonMessages{
    statusUpdated = "Status Updated Successfully",
    deleteConfirmation ="ARE YOU SURE YOU WANT TO DELETE ?",
    cloneConfirmation ="ARE YOU SURE YOU WANT TO ClONE ?",
    activeConfirmation ="Are you sure you want to active this journey ?",
    inactiveConfirmation ="Are you sure you want to inactive this journey ?",
    activeTemplateConfirmation ="Are you sure you want to active this template ?",
    inactiveTemplateConfirmation ="Are you sure you want to inactive this template ?",
    moveEmailTemplateConfirmation = "Are you sure you want to move this email template to another company?",
    activeInactiveConfirmation="Are you sure you want to change the status?",
    confirmRightToReject="Are you sure you want to remove this contact?",
    confirmationTitle ="Please confirm", 
    dialogDismissMessage='User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
  }

  
  export enum HelpAndTipsMessages{
    caseLogged = "Case logged successfully. Support team will get in touch with you via Email."
  }